import React from "react";
import styled from "styled-components";
import Images from "../../assets/images/Images";
import LanguageSelector from "../languageSelector/LanguageSelector";

const StyledTabFooter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  @media (max-width: 480px) {
    display: none;
  }
`;

const TabFooter: React.FC = () => {
  return (
    <StyledTabFooter>
      <LanguageSelector />
      <img src={ Images.eLogo } alt='Mapfre Economics' style={{ height: 49 }}/>
    </StyledTabFooter>
  );
};

export default TabFooter;
